var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.rootClass }, [
    _vm.isMagazineArticle
      ? _c("strong", { staticClass: "tit_view" }, [
          _c("em", { staticClass: "em_g" }, [_vm._v("공식팬카페")]),
          _vm._v(" 팬매거진")
        ])
      : _c("strong", { staticClass: "tit_view" }, [
          _c("em", { staticClass: "txt_point" }, [_vm._v("지난주,")]),
          _vm._v(" 카페 인기글")
        ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "list_hotview", attrs: { id: "list_hotview" } },
      _vm._l(_vm.renderedArticles, function(article) {
        return _c("card-item", {
          ref: "articleElements",
          refInFor: true,
          attrs: { article: article, config: _vm.config }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("ul", {
      staticClass: "nativead_wrap list_hotview",
      attrs: { id: "nativead_wrap" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wrap_btn" }, [
      _vm.renderedArticleCount < _vm.articles.length
        ? _c(
            "button",
            {
              staticClass: "btn_item btn_moreview",
              attrs: { type: "button" },
              on: { click: _vm.renderMoreArticles }
            },
            [_vm._v("더보기")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }